var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGstr1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t7cdtireua)",
    fill: "#676667"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.958 33c.99 0 1.792-.832 1.792-1.858 0-1.025-.802-1.857-1.792-1.857s-1.792.832-1.792 1.857c0 1.026.803 1.857 1.792 1.857zM28.5 33c.989 0 1.79-.832 1.79-1.858 0-1.025-.801-1.857-1.79-1.857-.99 0-1.793.832-1.793 1.857 0 1.026.803 1.857 1.792 1.857zM32.082 11.643H12.213l-.734-3.9a.935.935 0 0 0-.318-.54.876.876 0 0 0-.578-.203H7v1.857h2.849l3.421 17.829a.935.935 0 0 0 .319.54.876.876 0 0 0 .577.203h16.125v-1.857H14.9l-.735-3.715h16.125a.874.874 0 0 0 .572-.196.933.933 0 0 0 .323-.528l1.792-8.357a.961.961 0 0 0-.181-.793.902.902 0 0 0-.32-.256.87.87 0 0 0-.395-.084zM29.574 20H13.826l-1.254-6.5h18.39L29.575 20z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "t7cdtireua"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGstr1);
export default __webpack_public_path__ + "static/media/gstr1.619216645b6d0984a456c2389ea4a4c8.svg";
export { ForwardRef as ReactComponent };